import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import './index.css'
import axios from './plugins/axios'
import VueAxios from 'vue-axios'

import { initYandexMetrika } from 'yandex-metrika-vue3';

const app = createApp(App)
app.use(router)

app.use(initYandexMetrika, {
    id: 101576439,
    router: router,
    clickmap: true,
    webvisor: true,
    env: process.env.NODE_ENV
    //env: 'production'
    // other options
})

app.use(VueAxios, axios)

app.mount('#app')